"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[5104],{

/***/ 52314:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82805);



/***/ }),

/***/ 80647:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40554);



/***/ }),

/***/ 84301:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63134);
/* harmony import */ var components_modals_filter_generate_notebook_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97266);
/* harmony import */ var components_modals_practice_test_cannot_create_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97684);
/* harmony import */ var components_modals_practice_test_redirect_board_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47078);
/* harmony import */ var components_select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86325);
/* harmony import */ var utils_autofill_by_query_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19682);
/* harmony import */ var utils_current_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4042);
/* harmony import */ var utils_current_user__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(utils_current_user__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var utils_filter_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65917);
/* harmony import */ var utils_form_data_summary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55310);
/* harmony import */ var utils_disciplines_subjects_select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69033);










(function($) {
    const $filterForm = $('#js-questions-filter-form');
    const $disciplineSelect = $('#discipline_ids', $filterForm);
    const $subjectSelect = $('#subject_ids', $filterForm);
    const $filterFormToggle = $('#filter-form-desktop-toggle');
    const isUserSignedIn = window.currentUser;
    if (isUserSignedIn && localStorage && localStorage.getItem('showQuestionFilter')) {
        const isActive = localStorage.getItem('showQuestionFilter') === 'true';
        $filterFormToggle.prop('checked', !isActive).trigger('change');
    }
    utils_disciplines_subjects_select__WEBPACK_IMPORTED_MODULE_9__/* ["default"].init */ .Z.init($disciplineSelect, $subjectSelect);
    const searchQuery = gon.search_params || null;
    $filterForm.filterForm({
        track: true
    }).formDataSummary('.js-summary').autoFillByQueryString(searchQuery).lazyReady();
    $filterFormToggle.on('change', (e)=>{
        if (!localStorage) {
            return;
        }
        localStorage.setItem('showQuestionFilter', (!e.currentTarget.checked).toString());
    });
})(window.jQuery);


/***/ }),

/***/ 2361:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./components/select/index.js + 9 modules
var components_select = __webpack_require__(86325);
// EXTERNAL MODULE: ./utils/query_string/index.js
var query_string = __webpack_require__(48174);
// EXTERNAL MODULE: ./pages/questions/components/question_per_page_input/index.scss
var question_per_page_input = __webpack_require__(37737);
;// CONCATENATED MODULE: ./pages/questions/components/question_per_page_input/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



const PER_PAGE_PERMISSIONS = [
    'account',
    'confirmed_account',
    'subscription'
];
class QuestionPerPageInput {
    bindEvents() {
        this.$component.qselect('on', 'change', this.change.bind(this));
    }
    checkPerPageChangePermissions(value) {
        const defaultValuePerPage = '5';
        if (value === defaultValuePerPage) {
            return true;
        }
        const { proceed, reason } = window.permissions.hasPermissions(PER_PAGE_PERMISSIONS);
        if (proceed) {
            return true;
        }
        this.$component.qselect('close');
        const myEvent = new CustomEvent(reason, {
            detail: {
                type: 'per_page'
            }
        });
        window.permissions.feedbacks[reason](myEvent);
        if (!window.currentUser) {
            return;
        }
        UserTracker.emit('event', {
            eventName: 'account restriction reached',
            data: {
                'resource restricted': 'per page'
            }
        });
        return false;
    }
    change(value) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.checkPerPageChangePermissions(value)) {
                _this.$component.qselect('setValue', 5);
                return;
            }
            const query = query_string/* default.getQueryStringData */.Z.getQueryStringData();
            query.per_page = value;
            yield Thor.UserPreference.update({}, {
                data: {
                    user_preferences: {
                        questions_per_page: value
                    }
                }
            });
            Turbolinks.visit(`${location.pathname}?${query_string/* default.parseQueryStringData */.Z.parseQueryStringData(query)}`);
        })();
    }
    constructor(){
        this.$component = window.jQuery('.js-question-per-page');
        this.bindEvents();
    }
}
(function() {
    'use strict';
    new QuestionPerPageInput();
})();

// EXTERNAL MODULE: ./pages/questions/components/question_sort_input/index.scss
var question_sort_input = __webpack_require__(47451);
;// CONCATENATED MODULE: ./pages/questions/components/question_sort_input/index.js
function question_sort_input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function question_sort_input_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                question_sort_input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                question_sort_input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



class QuestionSortInput {
    bindEvents() {
        this.$sort.qselect('on', 'change', this.changeSort.bind(this));
    }
    checkSortPermissions() {
        const { proceed, reason } = window.permissions.hasPermissions(this.sortPermissions);
        if (proceed) {
            return true;
        }
        const myEvent = new CustomEvent(reason, {
            detail: {
                type: 'sort'
            }
        });
        this.$sort.qselect('close');
        window.permissions.feedbacks[reason](myEvent);
        if (!window.currentUser) {
            return;
        }
        UserTracker.emit('event', {
            eventName: 'account restriction reached',
            data: {
                'resource restricted': 'sort'
            }
        });
        return false;
    }
    changeSort(value) {
        var _this = this;
        return question_sort_input_async_to_generator(function*() {
            if (!_this.checkSortPermissions()) {
                return;
            }
            const query = query_string/* default.getQueryStringData */.Z.getQueryStringData();
            query.sort = value;
            yield Thor.UserPreference.update({}, {
                data: {
                    user_preferences: {
                        questions_sort: value
                    }
                }
            });
            Turbolinks.visit(`${location.pathname}?${query_string/* default.parseQueryStringData */.Z.parseQueryStringData(query)}`);
        })();
    }
    constructor(){
        this.$component = window.jQuery('.js-question-sort');
        this.$sort = window.jQuery('#sort', this.$component);
        this.sortPermissions = [
            'account',
            'confirmed_account',
            'subscription'
        ];
        this.bindEvents();
    }
}
(function() {
    'use strict';
    new QuestionSortInput();
})();

// EXTERNAL MODULE: ./pages/questions/components/questions_sub_filter_form/index.scss
var questions_sub_filter_form = __webpack_require__(2731);
// EXTERNAL MODULE: ./utils/stimulus/index.js
var stimulus = __webpack_require__(40225);
;// CONCATENATED MODULE: ./pages/questions/components/questions_sub_filter_form/index.js





const FONT_SIZES = [
    'small',
    'medium',
    'large',
    'extra-large'
];
class QuestionsToolsController extends stimulus/* Controller */.Q {
    initialize() {
        this.whatsNew();
        if (!this.isPageAllowed()) {
            window.jQuery('html').removeAttr('data-view-mode');
        }
        if (this.data.get('playgroundPrint') === 'true') {
            this.print({
                currentTarget: {
                    dataset: {
                        printUrl: this.data.get('printUrl')
                    }
                }
            });
        }
        window.addEventListener('turbolinks:before-render', ()=>{
            if (!this.isPageAllowed()) {
                this.restoreDefaultTheme();
            }
        });
        if (this.data.get('limitReached') === 'true') {
            const context = window.jQuery('.q-route-questions-index');
            window.jQuery('.q-root', context).addClass('q-print-page-not-allowed');
        }
    }
    whatsNew() {
        const whatsNewView = localStorage.getItem('whatsNewView');
        const statisticsButton = window.jQuery('#filter-statistics-button');
        const pulseCta = window.jQuery('.cta-pulse.cta-pulse-blue', statisticsButton);
        if (pulseCta.length && whatsNewView === 'true') {
            pulseCta.remove();
        }
        if (pulseCta.length && statisticsButton.length) {
            statisticsButton.on('click', ()=>{
                pulseCta.remove();
                localStorage.setItem('whatsNewView', true);
            });
        }
    }
    connect() {
        if (this.hasViewModeTarget) {
            this.$viewModeSelect = window.jQuery(this.viewModeTarget);
            this.$viewModeSelect.qselect('on', 'change', this.changeViewMode.bind(this));
        }
        this.loadState();
    }
    isPageAllowed() {
        const pathname = window.location.pathname;
        const parts = window.location.pathname.split('/');
        return window.jQuery('body').data('is-user-signed-in') && parts.pop() === 'questoes' && pathname.indexOf('/usuario/') < 0;
    }
    loadState() {
        if (!window.localStorage || !this.isPageAllowed()) {
            return;
        }
        const stateJSON = window.localStorage.getItem('questionSubFilterFormState');
        if (stateJSON) {
            this.state = JSON.parse(stateJSON);
            delete this.state.viewMode;
        }
        const { fontSize } = this.state;
        if (fontSize) {
            this.applyFontSize(fontSize);
        }
        if (this.$viewModeSelect) {
            this.$viewModeSelect.qselect('default');
        }
    }
    setState(option, value, inMemory = false) {
        this.state[option] = value;
        if (!inMemory) {
            this.saveState(inMemory);
        }
    }
    getState(option) {
        return this.state[option];
    }
    saveState() {
        if (window.localStorage) {
            window.localStorage.setItem('questionSubFilterFormState', JSON.stringify(this.state));
        }
    }
    applyFontSize(fontSize) {
        this.$questionListElement = this.$questionListElement || window.jQuery('.js-questions-list').get(0);
        this.$questionListElement.dataset.fontSize = fontSize;
    }
    applyViewMode(mode) {
        document.documentElement.dataset.viewMode = mode;
    }
    changeViewMode(e) {
        const mode = e instanceof Event ? e.currentTarget.dataset.mode : e;
        this.applyViewMode(mode);
        this.setState('viewMode', mode, false);
    }
    toggleNightMode() {
        const currentViewMode = this.getState('viewMode');
        this.changeViewMode(currentViewMode === 'night' ? 'default' : 'night');
    }
    restoreDefaultTheme() {
        const currentViewMode = this.getState('viewMode');
        if (currentViewMode !== 'default') {
            this.changeViewMode('default');
        }
    }
    changeFontSize(e) {
        const { actionType } = e.currentTarget.dataset;
        const current = this.getState('fontSize') || 'medium';
        const currentIndex = FONT_SIZES.indexOf(current);
        const targetIndex = actionType === 'increase' ? currentIndex + 1 : currentIndex - 1;
        const target = FONT_SIZES[targetIndex];
        if (targetIndex <= -1 || !target) {
            return;
        }
        this.applyFontSize(target);
        this.setState('fontSize', target);
    }
    print(e) {
        const currentViewMode = this.getState('viewMode');
        this.applyViewMode('default');
        const { printUrl } = e.currentTarget.dataset;
        window.print();
        this.applyViewMode(currentViewMode);
        // FIXME: Temporary solution to force page reload to count print limit for not subscribed users.
        Turbolinks.visit(printUrl);
    }
    constructor(...args){
        super(...args);
        this.state = {
            fontSize: 'medium'
        };
    }
}
QuestionsToolsController.targets = [
    'viewMode'
];
window.QuestionToolsApplication = window.QuestionToolsApplication || stimulus/* Application.start */.M.start();
window.QuestionToolsApplication.register('questions-tools', QuestionsToolsController);


/***/ })

}]);